import * as React from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import { useLocation, useNavigate, Outlet, Link } from 'react-router-dom';
import { Drawer, DrawerItem, DrawerContent } from '@progress/kendo-react-layout';
import { Button } from '@progress/kendo-react-buttons';
import { Alert } from './dashboard/Alert';
import { useGlobalState } from '../App.js';
import { useEffect } from 'react';
import edRights from '../data/edRights.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


export const DrawerContainer = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
    const [expanded, setExpanded] = React.useState(true);
    const [items, setItems] = React.useState([]);
  const [loginInfo, updateLoginInfo] = useGlobalState();

  const handleClick = () => {
    setExpanded(!expanded);
  };

  const onSelect = (e) => {
    navigate(e.itemTarget.props.route);
  };

  const setSelectedItem = (pathName) => {
    let currentPath = items.find((item) => item.route === pathName);
    if (currentPath.text) {
      return currentPath.text;
    }
  };

    const setupItems = () => {
        var navBar = [
            {
                text: 'Home',
                selected: true,
                route: '/home/dashboard',
                icon: 'fa-solid fa-tv fa-fw'
            }];
        // dashboard only
        if (loginInfo.rights.includes(edRights.Login)) {
           
                navBar = navBar.concat([{
                        text: 'External Systems',
                        selected: false,
                        route: '/home/externalsystems',
                    icon: 'fa-solid fa-plug fa-fw'
                }]);
            }
            
        setItems(navBar); 
    };

    const selected = '/';

    const CustomItem = (props) => {
        return (
            <DrawerItem {...props}>
                <div className="item-descr-wrap">
                    <div>
                <FontAwesomeIcon icon={props.icon} />
                    {props.text}</div>
                 </div>
            </DrawerItem>
        );
    };

    useEffect(() => {
        setupItems();
            }, [])

  return (
    <div>
      <div className="custom-toolbar">
        <Button icon="menu" onClick={handleClick} />
        <span className="overview">{selected === 'Eyedogz Dashboard'? 'Eyedogz Dashboard' : selected}</span>
        <div className="right-widget">
          <div className="alert-container">
                      <Alert />

                      <Link to="/home/about" style={{ color: '#424242', fontWeight: '400', fontSize: '14px', fontFamily: 'Roboto', marginTop: '3px' }}>About</Link>   
          </div>          
        </div>
      </div>

     <div>

     <div className='user-container' > 
        
                  <h1>Glenn</h1> 
       <div className="user-email">{loginInfo.email}</div> 
       <Link to="/"  style={{ textDecoration: 'none' }}>
       <Button className="user-button k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" 
       >Sign Out</Button> 
       </Link>
      </div>
      <Drawer
        expanded={expanded}
        position={'start'}
        mode={'push'}
        width={240}
        items={items.map((item) => ({
          ...item,
          selected: item.text === selected,
        }))}
        item={CustomItem}
        onSelect={onSelect}
        className="drawer"
      >
        <DrawerContent>{props.children}<Outlet/> </DrawerContent>
      </Drawer>
     </div>
 
    </div>

  );
};